import React from 'react'
import './imagetext.css';
import { LearnMore } from './learnmore';

export class ImageText extends React.Component {

    render() {
        return (
        <div className="background-container">
          <img className='hero-img' src="./cropped.jpg" alt="" />
          <div className="background-text">
            <div className='text-title'>
              <p>True Intelligence Requires Continuous Learning!</p>
            </div>
            <div className="text-desc"><p>Turn your knowledge into adaptive AI agents with effortless model training and deployment.</p></div>
            <div className='text-cta'><LearnMore to="/playground">Get Started</LearnMore></div>
          </div>
          <div className="banner">
            <p>Sign up today to get $10 free credits!</p>
          </div>
        </div>
      );
    }
}

